const style: any = (): any => ({
	input:{
		width: "100%",
	},
});

export default style;